// Registra public/service-worker.js — un SW mínimo sin caching (ver ese
// archivo) que solo existe para que Chrome ofrezca el prompt de "instalar
// app". Se registra en cualquier entorno con soporte (no solo producción)
// porque el propio manifest/instalabilidad se puede probar en dev.
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
      navigator.serviceWorker.register(swUrl).catch((error) => {
        console.error('Error al registrar el service worker:', error);
      });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
